import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AgentStatus {
  constructor() {}

  Statuses = {
    LoggedIn: {
      id: 1,
      label: 'Logged In',
      color: '#ff6624',
      iconClass: 'LoggedIn',
      canChange: true,
      menuEnabled: true,
    },
    LoggedOut: {
      id: 2,
      label: 'Logged Out',
      color: '#757575',
      iconClass: 'LoggedOut',
      canChange: false,
      menuEnabled: true,
    },
    Disconnected: {
      id: 3,
      label: 'Logged Out',
      color: '#757575',
      iconClass: 'LoggedOut',
      canChange: false,
      menuEnabled: true,
    },
    Resumed: {
      id: 4,
      label: 'Logged In',
      color: '#ff6624',
      iconClass: 'LoggedIn',
      canChange: true,
      menuEnabled: true,
    },
    OnCall: {
      id: 5,
      label: 'On Call',
      color: '#72bb53',
      iconClass: 'PhoneOnCall',
      canChange: false,
      menuEnabled: false,
    },
    InQueue: {
      id: 6,
      label: 'In Queue',
      color: '#ff6624',
      iconClass: 'Phone',
      canChange: true,
      menuEnabled: true,
    },
    PreCall: {
      id: 7,
      label: 'Pre-Call',
      color: '#59b5ce',
      iconClass: 'Phone',
      canChange: false,
      menuEnabled: true,
    },
    PostCall: {
      id: 8,
      label: 'Post-Call',
      color: '#59b5ce',
      iconClass: 'Phone',
      canChange: false,
      menuEnabled: false,
    },
    Away: {
      id: 9,
      label: 'Away',
      color: '#757575',
      iconClass: 'HangUp',
      canChange: true,
      menuEnabled: true,
    },
    OnDashboard: {
      id: 10,
      label: 'On Dashboard',
      color: '#ff6624',
      iconClass: 'PieChart',
      canChange: true,
      menuEnabled: true,
    },
    WaitingForCall: {
      id: 11,
      label: 'Waiting For Call',
      color: '#59b5ce',
      iconClass: 'PhoneWaiting',
      canChange: true,
      menuEnabled: true,
    },
    OnConsole: {
      id: 12,
      label: 'On Console',
      color: '#ff6624',
      iconClass: 'People',
      canChange: true,
      menuEnabled: true,
    },
    Auditing: {
      id: 13,
      label: 'Auditing',
      color: '#72bb53',
      iconClass: 'StarHalf',
      canChange: true,
      menuEnabled: true,
    },
    ExternalSystem: {
      id: 14,
      label: 'External System',
      color: '#ff6624',
      iconClass: 'External',
      canChange: true,
      menuEnabled: true,
    },
    AwayOnCall: {
      id: 15,
      label: 'Away - On Call',
      color: '#757575',
      iconClass: 'PhoneOnCall',
      canChange: false,
      menuEnabled: false,
    },
    AwayOnCallPersonal: {
      id: 16,
      label: 'Away - On Call',
      color: '#757575',
      iconClass: 'PhoneOnCall',
      canChange: false,
      menuEnabled: false,
    },
    ExternalAvailable: {
      id: 17,
      label: 'External Available',
      color: '#59b5ce',
      iconClass: 'PhoneWaiting',
      canChange: true,
      menuEnabled: true,
    },
    QueueSelection: {
      id: 18,
      label: 'Queue Selection',
      color: '#ff6624',
      iconClass: 'Menu',
      canChange: true,
      menuEnabled: true,
    },
    Default: {
      id: -1,
      label: 'Logged Out',
      color: '#757575',
      iconClass: 'LoggedOut',
      canChange: false,
      menuEnabled: false,
    },
  };

  getStatusByID(id) {
    for (const i in this.Statuses) {
      if (this.Statuses[i].id == id) return this.Statuses[i];
    }
    return this.Statuses.Default;
  }
}
